import { ImageComponent } from 'presentation/components/ImageComponent';

interface props {
    imageURLs: any;
}

export const ImageRow = ({ imageURLs }: props) => {
    return (
        <section className="center-inside" style={{ marginTop: 32, background: '#ffffff', marginBottom: 40}}>
            <ImageComponent
                parentClassName="h-164 full-width"
                className="image-inside min-h-[335px]"
                src={imageURLs[0].fileUrl}
            />
        </section>
    );
};
